










































import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class TopoSelect extends Vue {
  @Prop() public data!: any;
  @Prop() public current!: any;
  @Prop() public title!: string;
  @Prop() public icon!: string;
  public search: string = '';
  public visible: boolean = false;
  get filterData() {
    return this.data.filter((i: any) => i.label.toUpperCase().indexOf(this.search.toUpperCase()) !== -1);
  }
  public handleOpen() {
    this.visible = true;
  }
  public handleSelect(i: any) {
    this.$emit('onChoose', i);
    this.visible = false;
  }
}
